/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { typeOf } from '@ember/utils';
import SegmentModel from 'cio/models/segment';
import RavenService from 'cio/services/raven';
import { AddStyleVariant } from 'cio/components/condition-list';

interface EditorArgs {
  selectedSegments: SegmentModel[];
  disabled?: boolean;
  dropdownInitiallyOpened?: boolean;
  selectedNegate: boolean;
  segments: SegmentModel[];
  marginClass?: string;
  dropdownClass?: string;
  direction?: string;
  variation?: string;
  onChange: (newSegments: SegmentModel[]) => unknown;
  addStyle?: AddStyleVariant;
}

export default class Editor extends Component<EditorArgs> {
  @service raven!: RavenService;

  AddStyleVariants = AddStyleVariant;

  negates: Record<string, string | boolean>[] = [
    {
      value: false,
      label: 'in',
    },
    {
      value: true,
      label: 'not in',
    },
  ];

  @action
  updateSelectedSegments(newSegments: SegmentModel[]) {
    if (!Array.isArray(newSegments)) {
      let err = new TypeError(`Received ${typeOf(newSegments)} when an array was expected.`);

      this.raven.captureException(err, {
        extra: {
          unexpectedValue: newSegments,
        },
      });
    }

    this.args.onChange(newSegments);
  }
}
